import React, { useState, useEffect } from "react";
import axiosInstance from "../../config/axiosInterceptor";

// Utility to format date
const formatDate = (dateStr) =>
    new Date(dateStr).toLocaleString("en-IN", { hour12: true });

// Crown Icon Component
const CrownIcon = ({ size = 20 }) => (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="gold" style={{ marginLeft: 5, verticalAlign: "middle" }}>
        <path d="M3 13l2-7 5 5 5-5 2 7-7 4z" stroke="#ffbf00" strokeWidth="1.5" fill="gold" />
        <circle cx="3" cy="6" r="1" fill="#ffbf00"/>
        <circle cx="10" cy="3" r="1" fill="#ffbf00"/>
        <circle cx="17" cy="6" r="1" fill="#ffbf00"/>
    </svg>
);

const AudioIcon = ({ size = 22 }) => (
    <svg height={size} width={size} style={{ display: "inline", verticalAlign: "middle" }} viewBox="0 0 20 20" fill="#1d4ed8">
        <rect x="7" y="5" width="6" height="10" rx="3" />
        <path d="M13.7 8.29a1 1 0 0 1 1.4 1.42A5 5 0 0 1 10 15v-1.5a3.5 3.5 0 0 0 3.5-3.5 1 1 0 0 1 .2-1.21z" fill="#7da7f5" />
    </svg>
);

const VideoIcon = ({ size = 24 }) => (
    <svg height={size} width={size} style={{ display: "inline", verticalAlign: "middle" }} viewBox="0 0 20 20" fill="#17ad7d">
        <rect x="3" y="6" width="10" height="8" rx="2" />
        <polygon points="15,8 19,10 15,12" fill="#17ad7d" />
    </svg>
);

const styles = {
    container: {
        maxWidth: 1100,
        margin: "40px auto",
        padding: 28,
        background: "#fff",
        borderRadius: 18,
        boxShadow: "0 4px 28px 0 rgba(60, 72, 88, 0.14)",
        fontFamily: "Inter, Segoe UI, Arial, sans-serif",
    },
    topBar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 14,
        marginBottom: 22,
        flexWrap: "wrap",
    },
    header: {
        fontSize: 18,
        fontWeight: 600,
        color: "#194eb9",
        letterSpacing: "1px",
        flex: 1,
    },
    pagination: {
        display: "flex",
        alignItems: "center",
        gap: 6,
        background: "#f8faff",
        padding: "8px 16px",
        borderRadius: 8,
        boxShadow: "0 2px 7px 0 rgba(60,72,120,0.07)",
    },
    paginationBtn: {
        border: "1.3px solid #c5ccf3",
        background: "#f6f7ff",
        borderRadius: 7,
        padding: "7px 14px",
        fontSize: 15,
        color: "#2946c0",
        cursor: "pointer",
        fontWeight: 500,
        outline: "none",
        minWidth: 56,
        transition: "background .14s",
    },
    paginationBtnDisabled: {
        opacity: 0.53,
        cursor: "not-allowed",
    },
    select: {
        border: "1.3px solid #b9c2ea",
        borderRadius: 7,
        padding: "7px 20px 7px 7px",
        fontSize: 15,
        background: "#f9faff",
        outline: "none",
        marginLeft: 8,
    },
    filtersBar: {
        display: "flex",
        flexWrap: "wrap",
        gap: 12,
        alignItems: "center",
        marginBottom: 20,
        padding: "16px 0",
        borderBottom: "1.5px solid #e5e7ef",
        background: "#fafaff",
        borderRadius: 9,
    },
    input: {
        padding: "8px 12px",
        border: "1.5px solid #d6d8e7",
        borderRadius: 7,
        outline: "none",
        fontSize: 15,
        minWidth: 150,
        background: "#f9faff",
        transition: "border .15s",
    },
    button: {
        background: "linear-gradient(90deg, #2f62ef, #4883fe)",
        color: "#fff",
        border: "none",
        borderRadius: 7,
        padding: "9px 28px",
        fontWeight: 500,
        cursor: "pointer",
        fontSize: 15,
        transition: "background .2s",
        boxShadow: "0 2px 6px 0 rgba(50, 70, 130, .10)",
    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
        marginTop: 14,
        fontSize: 15.5,
        minWidth: 900,
    },
    th: {
        background: "#f5f8fe",
        fontWeight: 600,
        padding: "12px 8px",
        textAlign: "left",
        color: "#194eb9",
        borderBottom: "2px solid #e7eaf3",
        letterSpacing: "0.5px",
    },
    td: {
        padding: "13px 8px",
        borderBottom: "1.3px solid #f1f1f4",
        background: "#fff",
        verticalAlign: "middle",
    },
    tdAlt: {
        background: "#f7faff",
    },
    avatar: {
        width: 38,
        height: 38,
        borderRadius: "50%",
        marginRight: 11,
        objectFit: "cover",
        boxShadow: "0 1px 3px 0 rgba(34,60,130,.09)",
        border: "2px solid #e3e9fe",
    },
    username: {
        fontWeight: 500,
        color: "#2946c0",
        fontSize: 15.3,
        letterSpacing: ".1px",
    },
    coins: {
        fontWeight: 700,
        fontSize: 15.4,
    },
    coinsUser: {
        color: "#1d4ed8",
    },
    coinsReceiver: {
        color: "#159947",
    },
    summary: {
        fontSize: 15.1,
        color: "#555",
        marginBottom: 8,
        fontWeight: 500,
        letterSpacing: ".1px",
        padding: "0 3px",
    },
    pkTypeBox: {
        display: "flex",
        alignItems: "center",
        gap: 6,
        justifyContent: "center",
        fontWeight: 600,
        fontSize: 16,
        letterSpacing: "0.1px",
    },
};

export default function PkBattleList() {
    const [data, setData] = useState([]);
    const [totalEntries, setTotalEntries] = useState(0);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [status, setStatus] = useState("All");
    const [loading, setLoading] = useState(false);
    const [filterParams, setFilterParams] = useState({
        search: "",
        startDate: "",
        endDate: "",
        status: "All",
    });

    useEffect(() => {
        fetchBattles();
        // eslint-disable-next-line
    }, [page, entriesPerPage, filterParams]);

    const fetchBattles = async () => {
        setLoading(true);
        try {
            const params = {
                page,
                limit: entriesPerPage,
                ...filterParams,
            };
            const res = await axiosInstance.get(
                `${process.env.REACT_APP_BASEURL5}/admin/host/pkBattle`,
                { params }
            );
            setData(res.data.data);
            setTotalEntries(res.data.totalEntries);
            setEntriesPerPage(res.data.entriesPerPage);
        } catch (err) {
            alert("Error fetching data!");
        } finally {
            setLoading(false);
        }
    };

    const handleApplyFilters = () => {
        setFilterParams({
            search,
            startDate,
            endDate,
            status,
        });
        setPage(1); // Reset to first page
    };

    const handleStatusChange = (value) => {
        setStatus(value);
        setFilterParams((prev) => ({ ...prev, status: value }));
        setPage(1);
    };

    const totalPages = Math.ceil(totalEntries / entriesPerPage);

    return (
        <div style={styles.container}>
            <div style={styles.topBar}>
                <div style={styles.header}>
                    Total Entries: <span style={{ color: "#263c81" }}>{totalEntries}</span>
                </div>
                <div style={styles.pagination}>
                    <button
                        style={{
                            ...styles.paginationBtn,
                            ...(page === 1 ? styles.paginationBtnDisabled : {}),
                        }}
                        onClick={() => setPage((p) => Math.max(p - 1, 1))}
                        disabled={page === 1}
                    >
                        Prev
                    </button>
                    <span style={{ fontWeight: 500, fontSize: 15 }}>
                        {page} / {totalPages}
                    </span>
                    <button
                        style={{
                            ...styles.paginationBtn,
                            ...(page === totalPages ? styles.paginationBtnDisabled : {}),
                        }}
                        onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
                        disabled={page === totalPages}
                    >
                        Next
                    </button>
                    <select
                        style={styles.select}
                        value={entriesPerPage}
                        onChange={(e) => {
                            setEntriesPerPage(Number(e.target.value));
                            setPage(1);
                        }}
                    >
                        {[10, 20, 50, 100].map((v) => (
                            <option key={v} value={v}>
                                {v} / page
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            <div style={styles.filtersBar}>
                <input
                    style={styles.input}
                    placeholder="Search username..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
                <input
                    type="date"
                    style={styles.input}
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                />
                <input
                    type="date"
                    style={styles.input}
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                />
                <select
                    style={styles.select}
                    value={status}
                    onChange={(e) => handleStatusChange(e.target.value)}
                >
                    <option value="Archive">Archive</option>
                    <option value="Live">Live</option>
                    <option value="All">All</option>
                </select>
                <button style={styles.button} onClick={handleApplyFilters}>
                    Apply Filters
                </button>
            </div>
            <div style={styles.summary}>
                Showing <b>{(page - 1) * entriesPerPage + 1}</b> -{" "}
                <b>{Math.min(page * entriesPerPage, totalEntries)}</b> of{" "}
                <b>{totalEntries}</b> entries
            </div>
            {loading ? (
                <div style={{ textAlign: "center", padding: "48px 0", fontSize: 17 }}>
                    Loading...
                </div>
            ) : data.length === 0 ? (
                <div
                    style={{
                        textAlign: "center",
                        padding: "48px 0",
                        color: "#a0a1b5",
                        fontSize: 17,
                    }}
                >
                    No entries found.
                </div>
            ) : (
                <table style={styles.table}>
                    <thead>
                        <tr>
                            <th style={{ ...styles.th, textAlign: "center" }}>S. No.</th>
                            <th style={styles.th}>User1</th>
                            <th style={{ ...styles.th, textAlign: "center" }}>M-Coins</th>
                            <th style={{ ...styles.th, textAlign: "center" }}>PK Type</th>
                            <th style={styles.th}>User2</th>
                            <th style={{ ...styles.th, textAlign: "center" }}>
                                M-Coins
                            </th>
                            <th style={{ ...styles.th, textAlign: "center" }}>Status</th>
                            <th style={{ ...styles.th, textAlign: "center" }}>Created At</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, idx) => (
                            <tr key={row._id} style={idx % 2 === 1 ? styles.tdAlt : undefined}>
                                {/* S. No. */}
                                <td style={{ ...styles.td, textAlign: "center" }}>
                                    {(page - 1) * entriesPerPage + idx + 1}
                                </td>
                                {/* User */}
                                <td style={styles.td}>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <img
                                            src={
                                                row.user?.picture
                                                    ? process.env.REACT_APP_BASEURL + row.user.picture
                                                    : "/user.png"
                                            }
                                            alt="user"
                                            style={styles.avatar}
                                        />
                                        <span style={styles.username}>
                                            {row.user?.username || "-"}
                                            {row.winnerId && row.user?._id && row.winnerId === row.user._id && <CrownIcon />}
                                        </span>
                                    </div>
                                </td>

                                {/* User Diamonds */}
                                <td style={{ ...styles.td, textAlign: "center" }}>
                                    <span style={{ ...styles.coins, ...styles.coinsUser }}>
                                        {row.userIdCoins || 0}
                                    </span>
                                </td>
                                {/* PK Type */}
                                <td style={{ ...styles.td, textAlign: "center" }}>
                                    <span style={styles.pkTypeBox}>
                                        {row.pkType == 3 ? (
                                            <>
                                                <AudioIcon /> <span style={{ color: "#2356e2", marginLeft: 5 }}>Audio</span>
                                            </>
                                        ) : row.pkType == 1 ? (
                                            <>
                                                <VideoIcon /> <span style={{ color: "#19a580", marginLeft: 5 }}>Video</span>
                                            </>
                                        ) : (
                                            <span style={{ color: "#b9b9b9" }}>-</span>
                                        )}
                                    </span>
                                </td>
                                {/* Receiver */}
                                <td style={styles.td}>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <img
                                            src={
                                                row.receiver?.picture
                                                    ? process.env.REACT_APP_BASEURL + row.receiver.picture
                                                    : "/user.png"
                                            }
                                            alt="receiver"
                                            style={styles.avatar}
                                        />
                                        <span style={styles.username}>
                                            {row.receiver?.username || "-"}
                                            {row.winnerId && row.receiver?._id && row.winnerId === row.receiver._id && <CrownIcon />}
                                        </span>
                                    </div>
                                </td>
                                {/* Receiver Diamonds */}
                                <td style={{ ...styles.td, textAlign: "center" }}>
                                    <span style={{ ...styles.coins, ...styles.coinsReceiver }}>
                                        {row.receiverIdCoins || 0}
                                    </span>
                                </td>
                                <td>
                                    {row.status}
                                </td>
                                {/* Created At */}
                                <td style={{ ...styles.td, textAlign: "center" }}>
                                    {formatDate(row.createdAt)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}
